/* фикс UTF-8 */

import { ArmModalComponent } from './modal';

export default {
  name: 'ArmModalRequest',
  components: {
    'modalComponent': ArmModalComponent
  },
  template: `
    <modal-component :buttons="buttons">
      <div v-if="requestFormSuccess" class="used-form-success">
        <div>Спасибо!</div>
        <div>Ваша заявка отправлена!</div>
      </div>
      <div class="white-popup">
        <div class="used-form">
          <div class="used-form__title">Оставить заявку</div>
          <form action="" class="used-form__form" method="post">
            <div class="used-form__wrapper">
              <input
                type="text"
                class="used-form__input"
                v-model="formFields.name"
                autocomplete="off"
                @change="onChange"
              />
              <span class="used-form__name">ФИО</span>
              <span v-if="errors.name" class="used-form__error">Обязательное поле</span>
            </div>
            <div class="used-form__wrapper">
              <input
                ref="phone"
                type="phone"
                class="used-form__input"
                @change="onChange"
              />
              <span class="used-form__name">Телефон</span>
              <span v-if="errors.phone" class="used-form__error">Обязательное поле</span>
            </div>
            <br/>
            <div class="used-form__wrapper ">
              <div class="form-wrapper__item">
                <input type="checkbox" class="used-form__checkbox" v-model="formFields.policy" id="used-form__checkbox">
                <label for="used-form__checkbox" class="used-form__label">
                  <a href="/policy/" target="_blank">Даю согласие</a> на обработку моих персональных данных.
                </label>
              </div>
              <span v-if="errors.policy" class="used-form__error">Обязательное поле</span>
            </div>
          </form>
        </div>
      </div>
    </modal-component>
  `,
  props: {
    carId: {
      type: Number,
      default: 0
    },
    type: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      formFields: {
        name: '',
        phone: '',
        policy: false
      },
      errors: {
        name  : false,
        phone : false,
        policy: false,
      },
      requestFormSuccess: false,
      buttons: [
        {
          title: 'Отправить',
          handler: this.save
        }
      ]
    }
  },
  mounted() {
    this.$nextTick(() => {
      const mask = IMask(
        this.$refs.phone,
        {
          mask: '+{7} (000) 000-00-00',
        }
      );

      mask.on('accept', () => {
        this.formFields.phone = mask.value;
      });
    });
  },
  methods: {
    onChange(event) {
      const target = event.target; 
      if (target.value) {
        target.classList.add('used-form__input-fill');
      } else {
        target.classList.remove('used-form__input-fill');
      }
    },
    save() {
      let isError = false;
      
      for (const code in this.formFields) {
        if (Object.hasOwnProperty.call(this.formFields, code)) {
          if (!this.formFields[code]) {
            this.errors[code] = true;
            isError = true;
          } else {
            this.errors[code] = false;
          }
        }
      }

      if (isError) {
        return;
      }

      this.$emit('modals:disable', true);
      BX.ajax.runComponentAction(
        'arm:usedcars.detail',
        'saveRequest',
        {
          mode: 'class',
          data: {
            carId: this.carId,
            type : this.type,
            name : this.formFields.name,
            phone: this.formFields.phone,
          }
        }
      ).then(
        (response) => {
          this.$emit('modals:disable', false);
          if (response.status == 'success') {
            this.requestFormSuccess = true;
            setTimeout(() => this.$emit('modals:close'), 3000);
          }
        },
        (response) => {
          this.$emit('modals:disable', false);
          alert(response.errors[0].message);
        }
      );
    }
  }
};